import { render, staticRenderFns } from "./aiIntelligent.vue?vue&type=template&id=25a3896d&scoped=true"
import script from "./aiIntelligent.vue?vue&type=script&lang=js"
export * from "./aiIntelligent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a3896d",
  null
  
)

export default component.exports